(() => {
  const popup = document.querySelector('[data-sff-release-popup]');
  if (!popup || popup.dataset.initialized) return;
  popup.dataset.initialized = 'true';
  const key = 'sff-new-releases-last-shown-v2';
  const cooldown = 12 * 60 * 60 * 1000;
  let lastShown = 0;
  const triggers = document.querySelectorAll('[data-release-open]');
  let returnFocus = null;
  const read = storage => {
    try { return Number(storage.getItem(key)) || 0; } catch (_) { return 0; }
  };
  const readCookie = name => {
    try {
      const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(name + '='));
      return cookie ? cookie.slice(name.length + 1) : '';
    } catch (_) { return ''; }
  };
  const persistCookie = stamp => {
    const remaining = Math.ceil((stamp + cooldown - Date.now()) / 1000);
    if (remaining <= 0) return;
    try {
      document.cookie = key + '=' + stamp + '; Max-Age=' + remaining + '; Path=/; SameSite=Lax; Secure';
    } catch (_) {}
  };
  const seen = () => {
    let local = 0;
    let session = 0;
    try { local = read(window.localStorage); } catch (_) {}
    try { session = read(window.sessionStorage); } catch (_) {}
    const stamp = Math.max(lastShown, local, session, Number(readCookie(key)) || 0);
    const recent = stamp > 0 && Date.now() - stamp < cooldown;
    if (recent) persistCookie(stamp);
    return recent;
  };
  const remember = () => {
    lastShown = Date.now();
    try { window.localStorage.setItem(key, String(lastShown)); } catch (_) {}
    try { window.sessionStorage.setItem(key, String(lastShown)); } catch (_) {}
    persistCookie(lastShown);
  };
  const canRemember = () => {
    const testKey = key + '-test';
    try {
      window.localStorage.setItem(testKey, '1');
      const allowed = window.localStorage.getItem(testKey) === '1';
      window.localStorage.removeItem(testKey);
      if (allowed) return true;
    } catch (_) {}
    try {
      document.cookie = testKey + '=1; Max-Age=60; Path=/; SameSite=Lax; Secure';
      const allowed = readCookie(testKey) === '1';
      document.cookie = testKey + '=; Max-Age=0; Path=/; SameSite=Lax; Secure';
      return allowed;
    } catch (_) { return false; }
  };
  const open = (manual = false) => {
    if (document.visibilityState !== 'visible') {
      document.addEventListener('visibilitychange', () => { if (!seen()) open(false); }, { once: true });
      return;
    }
    if ((!manual && (seen() || !canRemember())) || document.querySelector('dialog[open], [aria-modal="true"]') || document.activeElement?.matches('input, textarea, select')) return;
    if (typeof popup.showModal !== 'function') return;
    returnFocus = document.activeElement;
    popup.showModal();
    document.documentElement.classList.add('sff-release-modal-open');
    triggers.forEach(button => button.setAttribute('aria-expanded', 'true'));
    remember();
  };
  popup.addEventListener('close', () => {
    document.documentElement.classList.remove('sff-release-modal-open');
    triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (returnFocus && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
  });
  triggers.forEach(button => button.addEventListener('click', () => open(true)));
  popup.addEventListener('cancel', remember);
  popup.querySelectorAll('[data-release-close]').forEach(button => button.addEventListener('click', () => popup.close()));
  popup.addEventListener('click', event => {
    if (event.target !== popup) return;
    const bounds = popup.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
  });
  const copy = popup.querySelector('[data-release-copy]');
  copy?.addEventListener('click', async () => {
    const status = popup.querySelector('[data-release-status]');
    try {
      await navigator.clipboard.writeText(copy.dataset.releaseCopy);
      copy.querySelector('[data-release-copy-label]').textContent = copy.dataset.copiedLabel;
      status.textContent = copy.dataset.copiedLabel;
    } catch (_) {
      const range = document.createRange();
      range.selectNodeContents(copy.querySelector('strong'));
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      status.textContent = copy.getAttribute('aria-label');
    }
  });
  const delay = Number(popup.dataset.delay) || 1800;
  if (document.readyState === 'complete') window.setTimeout(open, delay);
  else window.addEventListener('load', () => window.setTimeout(open, delay), { once: true });
})();
